export enum ThruCd {
  Derived = 'DERIVED'
}
